import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=1791a37e&"
import script from "./tabs.vue?vue&type=script&lang=ts&"
export * from "./tabs.vue?vue&type=script&lang=ts&"
import style0 from "./tabs.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports